function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  border-radius: ",
        ";\n  border: 2px solid currentColor;\n  color: #ffffff;\n  display: flex;\n  font-size: 12px;\n  font-weight: bold;\n  height: 32px;\n  justify-content: center;\n  line-height: 1;\n  padding: 1px 6px;\n  text-transform: uppercase;\n  width: 65px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 120%;\n  color: #ffffff;\n  text-shadow: 0px 2px 4px rgba(152, 163, 173, 0.36);\n  width: 100%;\n  word-break: break-word;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 24px;\n  max-width: 232px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  padding: 29px;\n  background: ",
        ";\n  background-size: cover;\n  width: 100%;\n  max-width: 383px;\n  min-height: 165px;\n  border-radius: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  margin: 0 19px 19px 0;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25);\n  flex: 1 0 auto;\n  background-position: center left;\n\n  &:hover {\n    cursor: pointer;\n\n    ",
        " {\n      border: 2px solid #fff;\n      background-color: #fff;\n      color: #242526;\n    }\n  }\n\n  @media (min-width: 1280px) {\n    margin-right: 23px;\n    width: 325px;\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { DEFAULT_SPECIALS_CARD_IMG } from 'shared/constants';
import { replaceAWSSourceWithImgix } from 'shared/helpers/imgix';
function BogoMenuCard(_param) {
    var _param_className = _param.className, className = _param_className === void 0 ? 'BogoCard' : _param_className, displayImage = _param.displayImage, displayName = _param.displayName, _param_href = _param.href, href = _param_href === void 0 ? null : _param_href, props = _object_without_properties(_param, [
        "className",
        "displayImage",
        "displayName",
        "href"
    ]);
    return /*#__PURE__*/ _jsxs(BogoCardContainer, _object_spread_props(_object_spread({
        className: "bogo-card-container ".concat(className),
        imageUrl: replaceAWSSourceWithImgix(displayImage) || DEFAULT_SPECIALS_CARD_IMG,
        href: href,
        as: href ? 'a' : 'div'
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(TextContainer, {
                children: /*#__PURE__*/ _jsx(Title, {
                    children: displayName
                })
            }),
            /*#__PURE__*/ _jsx(ActionsContainer, {
                children: /*#__PURE__*/ _jsx(ShopButton, {
                    children: "Shop"
                })
            })
        ]
    }));
}
var ShopButton = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_buttons;
    return (_theme_customized_radius_buttons = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.buttons) !== null && _theme_customized_radius_buttons !== void 0 ? _theme_customized_radius_buttons : '20px';
});
var ActionsContainer = styled.div(_templateObject1());
var Title = styled.p(_templateObject2());
var TextContainer = styled.div(_templateObject3());
var BogoCardContainer = styled.a(_templateObject4(), function(param) {
    var imageUrl = param.imageUrl;
    return "linear-gradient(180deg, rgba(11, 31, 50, 0.432) 33.75%, rgba(11, 31, 50, 0.9) 100%), url(".concat(imageUrl, ")");
}, function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_cards;
    return (_theme_customized_radius_cards = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.cards) !== null && _theme_customized_radius_cards !== void 0 ? _theme_customized_radius_cards : '20px';
}, ShopButton);
export default BogoMenuCard;
